import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../pages/listings.module.css';
import { truncate } from '../../utils/utils';
import { mapRFQStatus } from '../../utils/mapRFQStatus';

const RFQTable = ({ products }) => {
  const navigate = useNavigate();

  return (
    <>
      <table className='table table-striped table-hover'>
        <thead>
          <tr className={`${styles.headings}`}>
            <th scope='col'>#</th>
            <th scope='col'>Title</th>
            <th scope='col'>End User</th>
            <th scope='col'>Incoterm</th>
            <th scope='col'>Required Cert</th>
            <th scope='col'>Status</th>
            <th scope='col'>Destination City</th>
            <th scope='col'>Destination Country</th>
            <th scope='col'>Region</th>
            <th scope='col'>Required By</th>
            <th scope='col'>Updated At</th>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 ? (
            products.map((rfq, idx) => (
              <tr
                key={rfq.id}
                className={styles.rows}
                onClick={() => navigate(`/quantila/rfq/${rfq.id}`)}
              >
                <th scope='row'>{idx + 1}</th>
                <td>{truncate(rfq.title, 20)}</td>
                <td>{rfq.enduser}</td>
                <td>{rfq.Incoterm}</td>
                <td>{rfq.requiredCert}</td>
                <td>{mapRFQStatus(rfq.status)}</td>
                <td>{rfq.destinationCity}</td>
                <td>{rfq.destinationCountry}</td>
                <td>{rfq.region}</td>
                <td>
                  {rfq.requiredBy
                    ? new Date(rfq.requiredBy).toLocaleDateString('en-UK')
                    : ''}
                </td>
                <td>
                  {rfq.updatedAt
                    ? new Date(rfq.updatedAt).toLocaleString('en-UK', {
                        dateStyle: 'short',
                        timeStyle: 'short',
                      })
                    : ''}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={14}>No RFQs to display ...</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default RFQTable;
